class ServiceSwiper {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const windowWidth = $(window).width();
    const windowSm = 768;
    if (windowWidth <= windowSm) {
      const swiper = new Swiper(".s-service__swiper", {
        slidesPerView: 1,
        spaceBetween: 30,
      
        // ナビボタンが必要なら追加
        navigation: {
          nextEl: ".s-service__swiper-button-next",
          prevEl: ".s-service__swiper-button-prev",
        },

        scrollbar: {
          el: ".s-service__swiper-scrollbar",
          hide: false,
          draggable: true 
        },
      });
    } else {
    }
  }
}
